import { connect } from 'react-redux';
import CornerstoneWidgetBlock from './cornerstone-widget-block';
import { structure, single } from '../../../../core/store/actions/block';

const mapStateToProps = state => ({
  content: state.content,
  language: state.language
});

const mapDispatchToProps = {
  structure,
  single
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CornerstoneWidgetBlock);


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/cornerstone-widget-block-container.js